export const jsToken = 'HEXU'; //用于解密等操作